import {RecordData} from "../types/records-table.types";

export const defaultRecordData: RecordData = {
  id: 0
};
